import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Button Component - Versatile button with variants, sizes, loading state, and icons
 * @ownyou/ui-components
 */
import { cn } from '@ownyou/ui-design-system';
const VARIANT_CLASSES = {
    primary: 'bg-brand-600 text-white hover:bg-brand-700',
    secondary: 'bg-brand-100 text-brand-700 hover:bg-brand-200',
    ghost: 'bg-transparent hover:bg-neutral-100',
    danger: 'bg-error text-white hover:bg-red-600',
};
const SIZE_CLASSES = {
    sm: 'px-3 py-1.5 text-caption',
    md: 'px-4 py-2 text-body',
    lg: 'px-6 py-3 text-subhead',
};
function Spinner() {
    return (_jsxs("svg", { className: "animate-spin w-4 h-4", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "data-testid": "button-spinner", "aria-hidden": "true", children: [_jsx("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }), _jsx("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" })] }));
}
export function Button({ variant = 'primary', size = 'md', loading = false, leftIcon, rightIcon, fullWidth = false, children, disabled, className, ...rest }) {
    const isDisabled = disabled || loading;
    return (_jsxs("button", { disabled: isDisabled, className: cn('inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2', VARIANT_CLASSES[variant], SIZE_CLASSES[size], isDisabled && 'opacity-50 cursor-not-allowed', fullWidth && 'w-full', className), ...rest, children: [loading ? _jsx(Spinner, {}) : leftIcon, children, !loading && rightIcon] }));
}
export default Button;
